module.exports = __webpack_public_path__ + "fonts/Gilroy-Black.bde8bcef.woff";